<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      dark_mode: false,
      color_mode: "light",
      colors: ["#0077FF", "#cb4646", "#587991", "#464646", "#3a921d"],
      themes: [
        {
          key: "default",
          title: "Classic",
        },
        {
          key: "fresh",
          title: "Fresh",
        },
      ],
    };
  },
  mounted() {
    this.dark_mode = this.activeDarkMode;
    this.color_mode = this.dark_mode ? "dark" : "light";
  },
  methods: {
    ...mapMutations(["changeUserColor", "changeUserTheme"]),
    applyColorMode() {
      if (this.dark_mode) {
        document.body.classList.add("dark-mode");
        // document.documentElement.style.filter = 'invert(1)'
      } else {
        // document.documentElement.style.filter = 'none'
        document.body.classList.remove("dark-mode");
      }
    },
    setColorMode(mode) {
      this.color_mode = mode;
      this.dark_mode = mode === "dark";
      this.applyColorMode();
      this.$socket.emit("IN_UserThemeChange", {
        color: this.activeColor,
        name: this.activeTheme,
        dark_mode: this.dark_mode,
      });
    },
    changeColor(color) {
      this.changeUserColor(color);
      this.$socket.emit("IN_UserThemeChange", {
        color: color,
        name: this.activeTheme,
        dark_mode: this.activeDarkMode,
      });
    },
    changeTheme(theme) {
      this.changeUserTheme(theme);
      this.$socket.emit("IN_UserThemeChange", {
        color: this.activeColor,
        name: theme,
        dark_mode: this.activeDarkMode,
      });
    },
  },
  computed: {
    ...mapGetters(["getUserData"]),
    activeTheme() {
      if (this.getUserData.theme) {
        if (this.getUserData.theme.name) {
          return this.getUserData.theme.name;
        } else return "default";
      } else return "default";
    },
    activeColor() {
      if (this.getUserData.theme) {
        if (this.getUserData.theme.color) {
          return this.getUserData.theme.color;
        } else return "#0077FF";
      } else return "#0077FF";
    },
    activeDarkMode() {
      if (this.getUserData.theme) {
        if (this.getUserData.theme.dark_mode) {
          return this.getUserData.theme.dark_mode;
        } else return false;
      } else return false;
    },
  },
};
</script>

<template>
  <div>
    <div class="themes_content themes_content_bottom_border">
      <h2>{{ $t("settings.theme.customization.colors") }}</h2>
      <ul class="themes_colors">
        <li
          v-for="color of colors"
          :key="color"
          :class="activeColor == color ? 'active' : ''"
          @click="changeColor(color)"
        >
          <div :style="'background-color: ' + color"></div>
        </li>
      </ul>
    </div>
    <div class="themes_content themes_content_bottom_border">
      <h2>{{ $t("settings.theme.customization.icons") }}</h2>
      <div
        class="profile__content__background-item"
        style="overflow-y: auto; height: 152px; width: 80%; margin-top: 5px"
      >
        <div
          v-for="theme of themes"
          :key="theme.key"
          @click="changeTheme(theme.key)"
          :class="
            activeTheme == theme.key
              ? 'active background-item__block'
              : 'background-item__block'
          "
        >
          <div style="background-color: #eee">
            <img :src="require(`@/assets/static/images/themes/${theme.key}.jpg`)" alt="">
          </div>
          <span>{{ theme.title }}</span>
        </div>
      </div>
    </div>
    <div class="themes_content">
      <h2>{{ $t("settings.theme.customization.appearance") }}</h2>
      <div style="display: flex; justify-content: center; width: 250px">
        <label>
          <input
              type="radio"
              name="color-mode"
              value="light"
              style="margin-right: 5px"
              v-model="color_mode"
              @change="setColorMode('light')"
          >
          {{ $t("settings.theme.customization.light") }}
        </label>
        <label style="margin-left: 12px">
          <input
              type="radio"
              name="color-mode"
              value="dark"
              style="margin-right: 5px"
              v-model="color_mode"
              @change="setColorMode('dark')"
          >
          {{ $t("settings.theme.customization.dark") }}
        </label>
      </div>
    </div>
  </div>
</template>
